import React, { useContext } from 'react';
import { AccountsContext } from '../../contexts/AccountsContext';
import AccountCard from '../AccountCard/AccountCard';

function AccountsCards() {
  const { accounts } = useContext(AccountsContext);
  if (!accounts || !Array.isArray(accounts)) return null;

  return accounts.map((account) => <AccountCard key={account.id} {...account} />);
}

export default AccountsCards;



// WEBPACK FOOTER //
// ./routes/cpm/routes/accounts/components/AccountsCards/AccountsCards.jsx